import styled from "styled-components";
import {GameNumberBadgeDefaultBox} from "./game-number-badge.default.box";

export const GameNumberBadgeMrGreenBox = styled(GameNumberBadgeDefaultBox)`
    position: relative;
    top: -6px;
    right: -15px;
    font-size: 80px;
    font-family: "888-Orbit", verdana, sans-serif;
    font-weight: 900;
    text-shadow: none;
    color: white;
    -webkit-text-fill-color: white;
    -webkit-text-stroke-width: 3px;
    -webkit-text-stroke-color: ${props => props.theme.colors.brandPrimary};

    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        font-size: 100px;
    }
    
    &:first-of-type {
        right: -10px;
    }
`;